

<span
  [class.isOn] = 'isOn'
  (click) = 'switch()'
></span>
